import { call, put, takeEvery } from "redux-saga/effects";
import store from "redux/store";
import { rateCardApi, getCompanyDutyType } from "services/RateCardService";
import { GET_RATECARD, GET_COMPANYDUTY } from "resources/actionTypes";
import { getSubCity } from "redux/actions/UserRateCard";
import { getCar } from "redux/actions/UserCar";

function* fetchRateCard(action) {
  try {
    const payload = action.payload || {}
    const userRateCard = yield call(rateCardApi, payload);
    yield put({ type: GET_RATECARD.GET_RATECARD_SUCCESS, userRateCard: userRateCard });
  } catch (e) {
    yield put({ type: GET_RATECARD.GET_RATECARD_FAILED, message: e.message })
  }
}

export function* rateCardSaga() {
  yield takeEvery(GET_RATECARD.GET_RATECARD_REQUESTED, fetchRateCard);
}

function* fetchCompanyDuty(action) {

  const payload = action.payload || {}
    const userCompanyDuty = yield call(getCompanyDutyType, payload?.data);

    if (userCompanyDuty?.success) {
      yield put({ type: GET_COMPANYDUTY.GET_COMPANYDUTY_SUCCESS, userCompanyDuty: userCompanyDuty });

      if(payload?.type) {
        const payloadData = {
         ...payload?.data,
         type: userCompanyDuty?.data?.[0]?.tripType,
        }

        const dutyType = userCompanyDuty?.data?.map((val) => ({
          id: val.tripType,
          name: val.name,
        }));

        payload?.setSubCityStatus(dutyType?.[0]?.id === 4 ? 0 : 3);

        const filterValues = {
          ...payload?.filterValues,
          dutyType: dutyType?.[0]
        }

        payload?.setFilterValues(filterValues);

        if(userCompanyDuty?.data?.[0]?.tripType === 4) {
          store.dispatch(getSubCity(payload?.filterValues?.cityType?.id, "ratecard", payload?.setFilterValues, filterValues));
        }
        store.dispatch(getCar(payloadData, "ratecard", payload?.setFilterValues, filterValues))
      }
    }
    else {
      yield put({ type: GET_COMPANYDUTY.GET_COMPANYDUTY_FAILED, message: userCompanyDuty?.message })
    }
}

export function* companyDutySaga() {
  yield takeEvery(GET_COMPANYDUTY.GET_COMPANYDUTY_REQUESTED, fetchCompanyDuty);
}

